const modalInitialState = {
    modal: {
        show: false,
        data: {
            component: null,
            title: "",
            dissmiss: null,
            headerState: false,
            listBotones: null,
            posicion: null,
            bloquearDissmiss: null,
        }
    },
};

export default modalInitialState;